import { logger } from '../../helpers/logger';
import { amplitudeModule } from './AmplitudeModule';

export interface InitializeAmplitudeOptions {
  apiKey?: string;
  fetchRemoteConfig?: boolean;
  autocapture?: boolean;
  sessionReplaySampleRate?: number;
  enableSessionReplay?: boolean;
}

const isDev = process.env.NODE_ENV === 'development';

/**
 * Inicializa o Amplitude (via Ampli SDK) com Session Replay.
 * Chamar uma vez na raiz da aplicação.
 */
export function initializeAmplitude(options: InitializeAmplitudeOptions = {}): boolean {
  const apiKey = options.apiKey || process.env.REACT_APP_AMPLITUDE_API_KEY;

  if (!apiKey) {
    if (isDev) logger.warn('initializeAmplitude: API key não fornecida');
    return false;
  }

  try {
    amplitudeModule.init(apiKey, {
      fetchRemoteConfig: options.fetchRemoteConfig ?? true,
      autocapture: options.autocapture ?? false,
      sessionReplay: (options.enableSessionReplay ?? false)
        ? { sampleRate: options.sessionReplaySampleRate ?? 0.01 }
        : undefined,
    });

    return true;
  } catch (error) {
    if (isDev) logger.error('initializeAmplitude: Falha na inicialização', error);
    return false;
  }
}
